// @ts-nocheck
/* eslint-disable */
export const arrowNoBoxUpIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17"><path fill="#798693" d="M4.553 11.047h7.894c.64 0 .96-.774.506-1.227L9.5 6.367a1.42 1.42 0 0 0-2.007 0L6.18 7.68 4.04 9.82a.721.721 0 0 0 .513 1.227"/></svg>`,
    name: 'arrow-no-box-up' as const
};